import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';

import axiosMain from '../../../services';
const useStyles = makeStyles((theme) => ({
  tabPanel: {
    paddingTop: theme.spacing(1),
  },
}));

export default function ProfileTab() {
  const classes = useStyles();
  const history = useHistory();
  const [emailValue, setEmailValue] = useState('');
  const [usernameValue, setUsernameValue] = useState('');
  const [contactValue, setContactValue] = useState('');
  const [countryValue, setCountryValue] = useState('');
  const [addressValue, setAddressValue] = useState('');
  const [cityValue, setCityValue] = useState('');
  const [postalCodeValue, setPostalCodeValue] = useState('');
  const [errValue, setErrValue] = useState('');
  const [dpValue, setDp] = useState(null);
  const [fileName, setFileName] = useState('');

  useEffect(() => {
    axiosMain
      .get('/user/view')
      .then((response) => {
        if (response.status === 200) {
          const d = response.data;
          setUsernameValue(d.username || '');
          setEmailValue(d.email || '');
          setContactValue(d.number || '');
          setAddressValue(d.address || '');
          setCountryValue(d.country || '');
          setPostalCodeValue(d.postalCode || '');
          setCityValue(d.city || '');
          const pic = d.displayPicture != null ? d.displayPicture : null;
          setDp(pic);
          try {
            localStorage.setItem('dp', JSON.stringify(pic == null ? null : pic));
          } catch (_) {
            /* ignore */
          }
        }
      })
      .catch(() => {
        setErrValue('Could not load your profile.');
      });
  }, []);

  const handleUpdate = (e) => {
    e.preventDefault();
    setErrValue('');
    const payload = {
      username: usernameValue,
      email: emailValue,
      number: contactValue,
      address: addressValue,
      country: countryValue,
      city: cityValue,
      postalCode: postalCodeValue,
      displayPicture: dpValue != null && dpValue !== '' ? dpValue : null,
    };
    axiosMain
      .post('/user/update', payload)
      .then((response) => {
        if (response.status === 200) {
          toast.success('Profile updated.');
          try {
            localStorage.setItem('dp', JSON.stringify(dpValue != null && dpValue !== '' ? dpValue : null));
          } catch (_) {
            /* ignore */
          }
          window.location.reload();
        }
      })
      .catch((error) => {
        const msg = error?.response?.data?.message || 'Update failed.';
        setErrValue(msg);
        toast.error(msg);
      });
  };

  const onImageChange = (event) => {
    if (event.target.files && event.target.files[0]) {
      const f = event.target.files[0];
      setFileName(f.name);
      const reader = new FileReader();
      reader.onload = (ev) => {
        setDp(ev.target.result);
      };
      reader.readAsDataURL(f);
    }
  };

  return (
    <div className={classes.tabPanel}>
      {errValue ? (
        <Typography color="error" variant="body2" paragraph>
          {errValue}
        </Typography>
      ) : null}
      <div className="card">
        <div className="card-header">
          <h4 className="card-title">Profile</h4>
          <p className="mb-0 text-muted" style={{ fontSize: 13 }}>
            To change your password, use <strong>Forgot password</strong> on the sign-in page.
          </p>
        </div>
        <div className="card-body">
          <form
            onSubmit={(e) => {
              e.preventDefault();
              handleUpdate(e);
            }}
          >
            <div className="row g-4">
              <div className="col-xxl-6 col-xl-6">
                <label className="form-label">Your name</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Name"
                  value={usernameValue}
                  onChange={(e) => setUsernameValue(e.target.value)}
                />
              </div>
              <div className="col-xxl-6 col-xl-6">
                <label className="form-label">Email</label>
                <input
                  type="email"
                  className="form-control"
                  placeholder="Email"
                  value={emailValue}
                  onChange={(e) => setEmailValue(e.target.value)}
                />
              </div>
              <div className="col-xxl-12">
                <label className="form-label">Profile photo</label>
                <div className="d-flex align-items-center flex-wrap" style={{ gap: 12 }}>
                  {dpValue ? (
                    <img
                      className="rounded-circle"
                      src={dpValue}
                      width="72"
                      height="72"
                      alt=""
                      style={{ objectFit: 'cover' }}
                    />
                  ) : (
                    <div
                      className="rounded-circle d-flex align-items-center justify-content-center"
                      style={{ width: 72, height: 72, background: 'rgba(218,46,9,0.1)', border: '2px dashed rgba(218,46,9,0.3)' }}
                    >
                      <i className="icofont-user" style={{ fontSize: 28, color: '#DA2E09', opacity: 0.6 }} />
                    </div>
                  )}
                  <div className="form-file">
                    <input
                      type="file"
                      accept="image/*"
                      className="form-file-input"
                      id="settingsProfilePhoto"
                      onChange={onImageChange}
                    />
                    <label className="form-file-label" htmlFor="settingsProfilePhoto">
                      <span className="form-file-text">{fileName || 'Choose image…'}</span>
                      <span className="form-file-button">Browse</span>
                    </label>
                  </div>
                </div>
                <p className="text-muted small mt-2 mb-0">Upload a photo to show it here.</p>
              </div>
              <div className="col-xxl-6 col-xl-6">
                <label className="form-label">Contact number</label>
                <input
                  type="text"
                  className="form-control"
                  value={contactValue}
                  onChange={(e) => setContactValue(e.target.value)}
                />
              </div>
              <div className="col-xxl-12">
                <label className="form-label">Address</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Street, area"
                  value={addressValue}
                  onChange={(e) => setAddressValue(e.target.value)}
                />
              </div>
              <div className="col-xxl-4 col-xl-4">
                <label className="form-label">City</label>
                <input
                  type="text"
                  className="form-control"
                  value={cityValue}
                  onChange={(e) => setCityValue(e.target.value)}
                />
              </div>
              <div className="col-xxl-4 col-xl-4">
                <label className="form-label">Postal code</label>
                <input
                  type="text"
                  className="form-control"
                  value={postalCodeValue}
                  onChange={(e) => setPostalCodeValue(e.target.value)}
                />
              </div>
              <div className="col-xxl-4 col-xl-4">
                <label className="form-label">Country</label>
                <input
                  type="text"
                  className="form-control"
                  value={countryValue}
                  onChange={(e) => setCountryValue(e.target.value)}
                />
              </div>
              <div className="col-12">
                <button type="submit" className="btn btn-success pl-5 pr-5 waves-effect">
                  Save changes
                </button>
                <button type="button" className="btn btn-outline-secondary ml-2" onClick={() => history.push('/')}>
                  Back to dashboard
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
